/* eslint-disable @typescript-eslint/no-explicit-any */

import { isWeb } from "./capacitor";
import { confirmDialog } from "./quasar";

// import { modal } from "@/shared/EscapeAntd";
let count = 0; // UPDATE tip count
/**
 * Checks if the page has been updated.
 */
export const checkPageUpdate = () => {
  if (import.meta.env.VITE_NODE_ENV === "development" || !isWeb) return; // dev mode return
  (window as any).__COMMIT_HASH__ = __COMMIT_HASH__; // version mount to window
  const workerName =
    "FUXI_MOBILE_UPDATE_WORKER_" + import.meta.env.VITE_AUTH_ENV?.toUpperCase();
  if (window.SharedWorker) {
    const worker = new SharedWorker("/update-worker.js", workerName);
    // 接收 worker 的更新通知
    worker.port.onmessage = onmessage;
    // error
    worker.onerror = onerror;
  } else if (window.Worker) {
    const worker = new Worker("/update-worker2.js", {
      name: workerName + "2",
    });
    worker.onmessage = onmessage;
    worker.onerror = onerror;
    worker.postMessage("start"); // Notify the Worker to start checking for updates
  } else {
    console.log("UPDATE WORKER UNAVAILABLE!!!");
  }
};

async function onmessage(e: MessageEvent) {
  console.log("[BOWEN_LOG] 🚀 ~~ checkPageUpdate ~~ e:", e);
  if (e.data.type === "UPDATE") {
    if (count > 0) return;
    console.log("[BOWEN_LOG] ===== checkPageUpdate ===== UPDATE:", e);
    try {
      await confirmDialog({
        title: "更新提示",
        message: "检测到新版本，是否更新？",
      });
      window.location.reload();
    } catch (error) {
      console.log("用户已取消更新");
    }
    count++;
  }
}

function onerror(e: ErrorEvent) {
  console.dir(e);
  console.log(
    [
      "BOWEN_LOG ERROR: Line ",
      e.lineno,
      " in ",
      e.filename,
      ": ",
      e.message,
    ].join("")
  );
}
